define.alias("shared/components/shared/wizard/slide/footer", "settings/components/shared/wizard/slide/footer");